import { Grid,makeStyles}              from '@material-ui/core';
import React                           from 'react';

const useStyles =  makeStyles (theme =>({
    ContenedorLectura:{
        width:'502px',
                  [theme.breakpoints.down(502)]:{
            width:'350px',
            padding: '60px 0 0 0',
        },
        [theme.breakpoints.down(350)]:{
            width:'300px',
            padding: '30px 0 0 0',
        },
    },
    ContainerTitulo:{
        margin:'0 0 46px 0',
        '& .Titulo':{
            font:'43px fredoka one',
            letterSpacing: '0px',
            color: '#0CB5D6',
            margin:'0',
            textAlign:'center',
            [theme.breakpoints.down(502)]:{
                font:'30px fredoka one',
                lineHeight:'32px',
            },
            [theme.breakpoints.down(350)]:{
                font:'28px fredoka one',
                lineHeight:'32px',
            },
        },
      
    },
    Parrafo1:{
        margin:' 0 0 36px 0',
        '& .Lectura':{
            margin:'0 0 36px 0 ',
            color:'#000',
            font:'18px lato',
            lineHeight :'28px',
            letterSpacing: '0.17px',
            [theme.breakpoints.down(502)]:{
                font:'16px lato',
                lineHeight :'21px',
                letterSpacing: '0.09px',
            },
            [theme.breakpoints.down(350)]:{
                font:'12px lato',
                lineHeight :'17px',
                letterSpacing: '0.09px',
            },
        },

        '& .TextImg':{
            margin:'22px 0 0 0',
            color:'#717476',
            font:' 16px lato',
            lineHeight :'25px',
            letterSpacing: '0.15px',
            [theme.breakpoints.down(502)]:{
                font:' 11px lato',
                lineHeight :'14px',
                letterSpacing: '0.10px',
            },
        },  

        '& .SubTitulo':{
            margin:'0',
            color:'#FC5E9E',
            font:'bold 22px lato',
            lineHeight :'24px',
            letterSpacing: '0.21px',
            [theme.breakpoints.down(502)]:{
                font:'bold 18px lato',
                lineHeight :'20px',
                letterSpacing: '0.16px',
            },
        },
        '& .Imagen':{
            width:'100%',
        },

    },
    

}));

const Creatividad_el_impulso_del_arte = () => {
const classes = useStyles ()
    return (  
        <Grid container item justifyContent="center" xs={12} className={classes.Contenedor}>
            <Grid container item className={classes.ContenedorLectura} justifyContent="center">
                <Grid container item sm={12} className={classes.ContainerTitulo} justifyContent="center">
                    <h2 className="Titulo" >
                    Creatividad,<br/> el impulso del arte
                    </h2>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                        <p className="Lectura">
                        <h3 className="SubTitulo">El proceso creativo </h3><br/>

                            Un artista involucra distintos elementos en su oficio, como la inspiración, el talento, 
                            los conocimientos y la técnica. Al trabajo que realiza desde que inicia hasta que 
                            termina el producto final se le llama <em>proceso creativo.</em><br/><br/>  
                            
                            Dicha labor comienza cuando se tiene una idea y concluye cuando ésta se presenta 
                            ante el público, quien la recibe en forma de libro, disco, pintura, danza, obra teatral, 
                            escultura o edificio, entre otros.<br/><br/>  
                            
                            Así es. El arte está presente básicamente en todo lo que nos rodea: la música que 
                            escuchas en el transporte, las casas y edificios que habitas, los libros que lees en la 
                            escuela o que tienes en casa, y hasta los objetos más pequeños que utilizas en tu vida 
                            cotidiana pasaron por un proceso de imaginación, diseño y elaboración relacionados 
                            con el arte.<br/> <br/>  
                            
                            ¿Alguna vez te has preguntado cómo logran los artistas transformar una  
                            idea en una pieza de arte? Mediante la creatividad. 
                        </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <Grid container >
                            <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img2do/Sesion21/1.png" alt="Tarjeta" />
                        </Grid>
                        <Grid container justifyContent="center">
                            <p className='TextImg'>Todos tenemos la capacidad de desarrollar una o varias habilidades artísticas.</p>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                        <p className="Lectura">
                            <h3 className="SubTitulo">La creatividad</h3><br/>
                            Llamamos <em>creatividad</em> a la capacidad de crear cosas o de hallar soluciones diversas 
                            ante situaciones complejas. Surge en nuestra mente como una idea u ocurrencia y le 
                            damos forma de acuerdo con nuestras habilidades. Posiblemente en el pasado has 
                            escrito un poema o dibujado un paisaje. Los elementos que plasmas allí son producto 
                            de tu creatividad.<br/><br/> 
                            
                            Quizá te preguntes cómo se obtiene o de dónde viene la creatividad. Es una pregunta 
                            que todos nos hemos planteado alguna vez, cuando nos maravillamos ante una pieza 
                            musical que nos conmueve, ante un relato o una película.<br/>
                        </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <Grid container >
                            <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img2do/Sesion21/2.png" alt="Tarjeta" />
                        </Grid>
                        <Grid container >
                            <p className='TextImg'>
                                Las nueve musas de la mitología griega son divinidades que representan a las artes. Te
                                invitamos a buscar más información sobre estos personajes en la red.
                            </p>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                        <p className="Lectura">
                            Aunque en la antigua Grecia se creía que la creatividad provenía de la inspiración 
                            que brindaban las musas, ahora sabemos que todas las personas somos 
                            potencialmente creativas. Tu creatividad se entrena mientras lees, escribes, pintas, 
                            dibujas, tocas algún instrumento, bailas, cantas, representas piezas de teatro y (lo 
                            creas o no) juegas.<br/><br/> 
                            
                            ¿Has practicado alguna de estas actividades artísticas? Inténtalo. Además de 
                            mantener tu mente e instinto creativo activos, son una excelente opción para pasar 
                            ratos amenos en casa o con tus seres queridos en general.
                        </p>
                    </Grid>
                </Grid>
        </Grid>
    </Grid>
    );
}
 
export default Creatividad_el_impulso_del_arte;
